<div class="flex h-screen overflow-hidden bg-slate-50">
  <app-sidebar [menuItems]="menuItems"></app-sidebar>

  <main class="flex-1 flex flex-col min-w-0 mel-doodle-bg">
    <!-- Sticky Header (Breadcrumbs Only) -->
    <div class="sticky top-0 z-[500] bg-white border-b border-slate-50 shadow-xs">
      <div class="px-8 py-3 flex items-center justify-between">
        <app-breadcrumb [breadcrumbs]="breadcrumbs" [parentRoute]="parentRoute"></app-breadcrumb>
      </div>
    </div>

    <!-- Main  Content Area -->
    <div class="flex-1 overflow-y-auto p-6 md:p-8">
      <div class="max-w-[100rem] mx-auto space-y-6">
        <router-outlet></router-outlet>
      </div>
    </div>
  </main>
</div>
